import Axios from "./axios";

const resource = "promotion-billing-informations";

export default {
	create(data) {
		return Axios.post(`${resource}`, data);
	}
}